export const whatsAppNumberApp = "0557511482"    //+96 6503835468 
export const phoneNumberApp =" 013 8200191" //"013 8282994"
export const emailApp = "info@impact-tech.asia"
export const locationIndia = "#"
export const locationKsa = "https://maps.app.goo.gl/ibykp3eRwEoL5Kdy7"
export const facebookLink = "#"
export const twitterLink = "#"
export const instagramLink = "#"
export const linkedinLink = "#"